export default (...parameters) => {
    window.dataLayer.push(...parameters);
};
